
/*
Copyright (c) 2018 Ady Levy
Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.
THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
import Dialog from "@material-ui/core/Dialog"
import DialogActions from "@material-ui/core/DialogActions"
import DialogTitle from "@material-ui/core/DialogTitle"
import { withStyles } from "@material-ui/core/styles"
import { fade } from "@material-ui/core/styles/colorManipulator"
import IconCancel from "@material-ui/icons/Cancel"
import ActionDelete from "@material-ui/icons/Delete"
import classnames from "classnames"
import PropTypes from "prop-types"
import { crudDelete, startUndoable, translate, crudDeleteMany } from "ra-core"
import React, { Component } from "react"
import { Button } from "react-admin"
import { connect } from "react-redux"
import compose from "recompose/compose"


interface Theme {
  palette: {
    error: any
  }
}

function styles (theme: Theme) {
  return {
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: fade(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }
}


interface DelButtonProps {
  dispatchCrudDelete: any
  dispatchCrudDeleteMany: any
  startUndoable: any
  resource: any
  record: any
  selectedIds: string[]
  basePath: string
  redirect: any
  undoable: any
}

interface State {
  showDialog: boolean
}

class DeleteButtonWithConfirmation extends Component {
  constructor (props: DelButtonProps) {
    super(props)
    this.state = {
      showDialog: false,
    } as State
    // @ts-expect-error
    this.handleClick = () => {
      this.setState({ showDialog: true })
    }
    // @ts-expect-error
    this.handleCloseClick = () => {
      this.setState({ showDialog: false })
    }
    // @ts-expect-error
    this.handleDelete = (event) => {
      event.preventDefault()
      this.setState({ showDialog: false })
      const {
        dispatchCrudDelete,
        dispatchCrudDeleteMany,
        startUndoable,
        resource,
        record,
        selectedIds,
        basePath,
        redirect,
        undoable,
      } = (this.props as DelButtonProps)

      if (record) {
        if (undoable) {
          startUndoable(
            crudDelete(resource, record.id, record, basePath, redirect),
          )
        }
        else {
          dispatchCrudDelete(
            resource,
            record.id,
            record,
            basePath,
            redirect,
          )
        }
      }
      else if (selectedIds) {
        if (undoable) {
          startUndoable(
            crudDeleteMany(resource, selectedIds, basePath, redirect),
          )
        }
        else {
          dispatchCrudDeleteMany(
            resource,
            selectedIds,
            record,
            basePath,
            redirect,
          )
        }
      }
    }
  }

  render () {
    const { showDialog } = this.state as State
    const {
      label = "ra.action.delete",
      classes = {},
      className,
    } = this.props as any

    return (
      <>
        <Button
          // @ts-expect-error
          onClick={this.handleClick}
          label={label}
          className={
            classnames("ra-delete-button", classes.deleteButton, className)
          }
          key='button'
        >
          <ActionDelete />
        </Button>
        <Dialog
          fullWidth
          open={showDialog}
          // @ts-expect-error
          onClose={this.handleCloseClick}
          aria-label='Are you sure?'
        >
          <DialogTitle>Are you sure you want to delete?</DialogTitle>
          <DialogActions>
            <Button
              // @ts-expect-error
              onClick={this.handleDelete}
              label={label}
              className={
                classnames("ra-delete-button", classes.deleteButton, className)
              }
              key='button'
            >
              <ActionDelete />
            </Button>
            <Button
              label='ra.action.cancel'
              // @ts-expect-error
              onClick={this.handleCloseClick}
            >
              <IconCancel />
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}

// @ts-expect-error
DeleteButtonWithConfirmation.propTypes = {
  basePath: PropTypes.string,
  classes: PropTypes.object,
  className: PropTypes.string,
  dispatchCrudDelete: PropTypes.func.isRequired,
  label: PropTypes.string,
  record: PropTypes.object,
  redirect: PropTypes.oneOfType(
    [PropTypes.string, PropTypes.bool, PropTypes.func],
  ),
  resource: PropTypes.string.isRequired,
  startUndoable: PropTypes.func,
  translate: PropTypes.func,
  undoable: PropTypes.bool,
}

// @ts-expect-error
DeleteButtonWithConfirmation.defaultProps = {
  redirect: "list",
  undoable: true,
}

export default compose(
  connect(
    null,
    { startUndoable, dispatchCrudDelete: crudDelete },
  ),
  translate,
  withStyles(styles),
// @ts-expect-error
)(DeleteButtonWithConfirmation)
